"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Endpoints_1 = require("../../Utils/Endpoints");
var Services_1 = require("../../Services");
require("../Styles/TwoFactorAuthentication.css");
var TwoFactorAuthentication = /** @class */ (function (_super) {
    __extends(TwoFactorAuthentication, _super);
    function TwoFactorAuthentication(props) {
        var _this = _super.call(this, props) || this;
        _this.requestCode = function () {
            Services_1.getJson(Endpoints_1.default.SendTwoFactorCode, undefined, true, new Services_1.UserRequestHeaders(Services_1.Auth.getUser()));
        };
        _this.handleCodeValidationAsync = function () { return __awaiter(_this, void 0, void 0, function () {
            var code, response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        code = ((_a = this.inputRef.current) === null || _a === void 0 ? void 0 : _a.value) || "";
                        return [4 /*yield*/, Services_1.Auth.validateCodeAsync(code)];
                    case 1:
                        response = _b.sent();
                        if (response.isValid) {
                            Services_1.Auth.twoFactorComplete(code);
                            this.props.forceAppUpdate();
                        }
                        else {
                            console.error("failed with reason: " + response.reason.value);
                            this.setState({ validationResult: response });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            validationResult: { isValid: true, reason: "" }
        };
        _this.inputRef = React.createRef();
        return _this;
    }
    TwoFactorAuthentication.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var code, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        code = Services_1.Auth.getTwoFactorCode();
                        if (!(code != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Services_1.Auth.validateCodeAsync(code)];
                    case 1:
                        response = _a.sent();
                        if (response.isValid) {
                            Services_1.Auth.twoFactorComplete(code);
                            this.props.forceAppUpdate();
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        this.requestCode();
                        return [2 /*return*/];
                }
            });
        });
    };
    TwoFactorAuthentication.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement("div", { className: "tfa-container" },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("img", { src: this.props.siteLogo, alt: "VeriLite" })),
                React.createElement("div", null,
                    React.createElement("img", { src: this.props.companyLogo, alt: "Solidsoft Reply" }))),
            React.createElement("div", null,
                React.createElement(reactstrap_1.Card, { inverse: true, color: "primary", className: "border-none" },
                    React.createElement(reactstrap_1.CardBody, null,
                        React.createElement(reactstrap_1.CardTitle, { tag: "h3" }, (_a = this.props.resources) === null || _a === void 0 ? void 0 : _a.Page_TwoFactorAuth_PleaseEnterYourAuthCode),
                        React.createElement(reactstrap_1.CardText, { dangerouslySetInnerHTML: { __html: ((_b = this.props.resources) === null || _b === void 0 ? void 0 : _b.Page_TwoFactorAuth_Description) || "" } }),
                        React.createElement(reactstrap_1.Row, { className: "tfa-code-row my-5 mx-auto" },
                            React.createElement(reactstrap_1.Col, { xs: "auto", className: "tfa-code-text " }, (_c = this.props.resources) === null || _c === void 0 ? void 0 :
                                _c.Page_TwoFactorAuth_Code,
                                ":"),
                            React.createElement(reactstrap_1.Col, { xs: "6" },
                                React.createElement(reactstrap_1.Input, { invalid: !this.state.validationResult.isValid, innerRef: this.inputRef }),
                                React.createElement(reactstrap_1.FormFeedback, { className: "tfa-feedback-text" }, !this.state.validationResult.isValid && this.state.validationResult.reason.value)),
                            React.createElement(reactstrap_1.Col, { xs: "3", className: "tfa-send-again-btn ml-auto" },
                                React.createElement(reactstrap_1.Button, { outline: true, color: "light", onClick: this.requestCode }, (_d = this.props.resources) === null || _d === void 0 ? void 0 : _d.Page_TwoFactorAuth_SendAgain))),
                        React.createElement(reactstrap_1.Row, { className: "tfa-button-row m-3" },
                            React.createElement(reactstrap_1.Button, { outline: true, color: "light", onClick: this.handleCodeValidationAsync }, (_e = this.props.resources) === null || _e === void 0 ? void 0 : _e.Page_TwoFactorAuth_Continue),
                            React.createElement(reactstrap_1.Button, { outline: true, color: "light", onClick: Services_1.Auth.logout }, (_f = this.props.resources) === null || _f === void 0 ? void 0 : _f.Cancel)))))));
    };
    return TwoFactorAuthentication;
}(React.Component));
exports.TwoFactorAuthentication = TwoFactorAuthentication;
//# sourceMappingURL=TwoFactorAuthentication.js.map